import { render } from "./CoachDetails.vue?vue&type=template&id=28acbd2b"
import script from "./CoachDetails.vue?vue&type=script&lang=js"
export * from "./CoachDetails.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Shehab\\Coding\\vue\\Maxmillian\\Vue-The-Complete-Guide\\lec 18\\deploy01-starting-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__